import React, { useState, useEffect } from 'react';
import "../css/Login.css";
import Logo from "../assets/logonew.jpeg"
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Loader from "../components/Loader";


function Login() {
    const [userType, setUserType] = useState('admin');
    const [userCode, setUserCode] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);


    // Card slider content
    const slides = [
        {
            title: "Student Management",
            description: "Manage student records, attendance, and academic performance with ease.",
            icon: "fas fa-user-graduate"
        },
        {
            title: "Teacher Portal",
            description: "Streamline lesson planning, grading, and communication with students.",
            icon: "fas fa-chalkboard-teacher"
        },
        {
            title: "Parent Access",
            description: "Keep parents updated on their children's progress and school activities.",
            icon: "fas fa-users"
        }
    ];

    // Auto-slide functionality
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide(prevSlide => (prevSlide + 1) % slides.length);
        }, 5000);

        return () => clearInterval(interval);
    }, [slides.length]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loginData = {
            userType,
            userCode,
            password,
        };
        try {
            const response = await fetch("https://schoolpro-api.uniums.com/users/login", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(loginData),
            });
            const data = await response.json();
            if (response.ok) {
                localStorage.setItem("token", data.token);
                localStorage.setItem("role", data.role);
                localStorage.setItem("userId", data.userId);
                toast.success("Login successful!");
                // Handle redirects based on user type
                if (data.role === "admin") {
                    navigate("/dashboard");
                } else if (data.role === "teacher") {
                    navigate("/dashboard/teacher");
                } else if (data.role === "student") {
                    navigate("/student/dashboard");
                } else {
                    navigate("/");
                }
            } else {
                toast.error(data.message || "Invalid username or password");
            }
        } catch (error) {
            console.error("Error during login:", error);
            toast.error("An error occurred. Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-container">
            <div className="login-books-bg"></div>
            <div className="login-card">
                <div className="login-left-panel">
                    <div className="login-logo">
                        <h2>SCHOOLPRO</h2>
                        <p>SOFTWARE</p>
                        <small>professional school management system</small>
                    </div>

                    <div className="login-slider">
                        {slides.map((slide, index) => (
                            <div
                                key={index}
                                className={`login-slide ${index === currentSlide ? 'login-slide-active' : ''}`}
                            >
                                <div className="login-slide-icon">
                                    <i className={slide.icon}></i>
                                </div>
                                <h3>{slide.title}</h3>
                                <p>{slide.description}</p>
                            </div>
                        ))}

                        <div className="login-slider-dots">
                            {slides.map((_, index) => (
                                <span
                                    key={index}
                                    className={`login-dot ${index === currentSlide ? 'login-dot-active' : ''}`}
                                    onClick={() => setCurrentSlide(index)}
                                ></span>
                            ))}
                        </div>
                    </div>

                    <div className="login-social-icons">
                        <a href="#" className="login-social-icon"><i className="fab fa-facebook-f"></i></a>
                        <a href="#" className="login-social-icon"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="login-social-icon"><i className="fab fa-linkedin-in"></i></a>
                        <a href="#" className="login-social-icon"><i className="fab fa-youtube"></i></a>
                    </div>
                </div>
                <div className="login-right-panel">
                    <div className="login-school-logo">
                        <img src={Logo} alt="The uniums School" />
                        <h3>THE UniUMS SCHOOL</h3>
                    </div>
                    <form className="login-form" onSubmit={handleSubmit}>
                        <div className="login-user-type">
                            <label className={`login-type-option ${userType === 'admin' ? 'login-type-active' : ''}`}>
                                <input
                                    type="radio"
                                    name="userType"
                                    value="admin"
                                    checked={userType === 'admin'}
                                    onChange={() => setUserType('admin')}
                                />
                                <span>Admin</span>
                            </label>
                            <label className={`login-type-option ${userType === 'teacher' ? 'login-type-active' : ''}`}>
                                <input
                                    type="radio"
                                    name="userType"
                                    value="teacher"
                                    checked={userType === 'teacher'}
                                    onChange={() => setUserType('teacher')}
                                />
                                <span>Teacher</span>
                            </label>
                            <label className={`login-type-option ${userType === 'student' ? 'login-type-active' : ''}`}>
                                <input
                                    type="radio"
                                    name="userType"
                                    value="student"
                                    checked={userType === 'student'}
                                    onChange={() => setUserType('student')}
                                />
                                <span>Guardian</span>
                            </label>
                        </div>
                        <div className="login-input-group">
                            <input
                                type="text"
                                placeholder={userType === 'teacher' ? "Employee ID" : "User Code"}
                                className="login-input"
                                value={userCode}
                                onChange={(e) => setUserCode(e.target.value)}
                                required
                            />
                        </div>
                        <div className="login-input-group">
                            <input
                                type="password"
                                placeholder="Password"
                                className="login-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>
                        <div className="login-options">
                            <label className="login-remember">
                                <input
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                />
                                <span>Remember</span>
                            </label>
                            <Link to={'/forgot-password'} className="login-forgot">Forgot Password?</Link>
                        </div>
                        <button type="submit" className="login-button" disabled={loading}>
                            {loading ? 'Logging in...' : 'Login'}
                        </button>
                    </form>
                </div>
            </div>
            {loading && <Loader />}
            <ToastContainer />
        </div>
    );
}

export default Login;